<div class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">

    <form [formGroup]="formGroup" novalidate>

        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtOrderNo}}" formControlName="OrderNo" 
                       [(ngModel)]="parent.order.OrderNo">
                <!-- <mat-error *ngIf="formGroupErrors.OrderNo.required">
{{translations.msgPleaseEnterOrderNo}}
</mat-error> -->
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput [matDatepicker]="dp3" placeholder="{{translations.txtRegistrationDate}}" 
                       formControlName="RegistrationDate" readonly
                       [(ngModel)]="parent.order.RegistrationDate" required>
                <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                <mat-error *ngIf="formGroupErrors.RegistrationDate.required">
                    {{translations.msgPleaseEnterRegistrationDate}}
                </mat-error>
            </mat-form-field>

        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="50">
                <mat-select placeholder="{{translations.cmbShipper}} " formControlName="ShipperId" 
                            [(ngModel)]="parent.order.ShipperId" required >
                    <mat-option *ngFor="let shipper of shipperList" [value]="shipper.Id">{{shipper.Name}} ({{shipper.Code}})</mat-option>
                </mat-select>
                <mat-error *ngIf="formGroupErrors.ShipperId.required">
                    {{translations.msgPleaseSelectShipper}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input #shipperOrderNumber matInput placeholder="{{translations.txtInvoiceNo}}" formControlName="InvoiceNo" 
                       [(ngModel)]="parent.order.InvoiceNo" required maxlength="25" (change)="validate(shipperOrderNumber.value)">
                <mat-error *ngIf="formGroupErrors.InvoiceNo.required">
                    {{translations.msgPleaseEnterInvoiceNo}}
                </mat-error>
                <mat-hint *ngIf="isExists">
                    {{translations.errShipperOrderNumberExists}}
                </mat-hint>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="33">
                <mat-select placeholder="{{translations.cmbArticle}}" formControlName="AticleId" 
                            [(ngModel)]="parent.order.AticleId" required>
                    <mat-option *ngFor="let artical of articalList" [value]="artical.Id">{{artical.Text}}</mat-option>
                </mat-select>
                <mat-error *ngIf="formGroupErrors.AticleId.required">
                    {{translations.msgPleaseSelectArticle}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="34">
                <mat-select placeholder="{{translations.cmbOrderType}}" formControlName="TypeId" 
                            [(ngModel)]="parent.order.TypeId" required (selectionChange)="changeColor($event)" class="{{otColor}}">
                    <mat-option *ngFor="let otrderType of orderTypeList" [value]="otrderType.Id" 
                                [style.color]="otrderType.Value">{{otrderType.Text}}</mat-option>
                </mat-select>
                <mat-error *ngIf="formGroupErrors.TypeId.required">
                    {{translations.msgPleaseSelectOrderType}}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="30">
                <mat-select placeholder="{{translations.cmbOrderStatus}}" formControlName="Status" 
                            [(ngModel)]="parent.order.Status" required (selectionChange)="changeColor($event)" class="{{oStatus}}">
                    <mat-option *ngFor="let orderStatus of orderStatusList" [value]="orderStatus.Id" 
                                [style.color]="orderStatus.Value">{{orderStatus.Text}}</mat-option>
                </mat-select>
                <mat-error *ngIf="formGroupErrors.Status.required">
                    {{translations.msgPleaseSelectOrderStatus}}
                </mat-error>
                <!--  <mat-hint *ngIf="!canUpdateToDelivered">
{{translations.errShipperOrderNumberExists}}
</mat-hint> -->
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start" disabled>
           <mat-form-field class="mr-24 single-field" fxFlex.xs="100" fxFlex="50" style="max-width: 48% !important;">
                <input matInput [matDatepicker]="dp5" placeholder="{{translations.txtPlannedDate}}" formControlName="D_PlannedDate" [(ngModel)]="parent.order.D_PlannedDate" readonly>
                <mat-icon  matSuffix (click)="parent.order.D_PlannedDate = ''" style="font-size:15px;cursor: pointer;">close</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="dp5"></mat-datepicker-toggle>
                <mat-datepicker #dp5 disabled="false"></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput [matDatepicker]="dp6" placeholder="{{translations.txtActualDate}}" formControlName="D_ActualDate" [(ngModel)]="parent.order.D_ActualDate"
                    readonly>
                <mat-icon matSuffix (click)="parent.order.D_ActualDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>
                <mat-datepicker-toggle matSuffix [for]="dp6"></mat-datepicker-toggle>
                <mat-datepicker #dp6 disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>
    </form>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/order-detail/order-detail.component.html